import React from "react";
import "./Filter_offcanvas.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import Green_round_btn from "../../../common-components/common_btn/green_round_btn/Green_round_btn";
import { Accordion, Form } from "react-bootstrap";
import Success_Modal from "../../../common-components/common_modal/success_modal/Success_Modal";

function Filter_offcanvas({
  show,
  handleClose,
  filters,
  updateFilter,
  handleApplyFilters,
  handleClearFilters,

  categories,
  subCategories,
  colours,
  sizes,
  brands,
  ...props
}) {
  const [modalShow, setModalShow] = React.useState(false);
  const handleClick = () => {
    setModalShow(true);
    setTimeout(() => {
      setModalShow(false);
    }, 3000);
  };
  return (
    <>
      <Offcanvas
        className="Filter_offcanvas"
        show={show}
        onHide={handleClose}
        placement="start"
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h4 className="heading_text">Filters</h4>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="Accordion_holder">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Collection</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    {/* <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"Kurtas"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Inner Wear"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Cord Set"}
                      />
                    </Form> */}

                    <Form>
                      {categories?.map((item) => (
                        <Form.Check
                          key={item.id}
                          type="checkbox"
                          label={item.name}
                          checked={filters.category.includes(item.id)}
                          onChange={(e) => {
                            let updated = [...filters.category];

                            if (e.target.checked) {
                              updated.push(item.id);
                            } else {
                              updated = updated.filter((x) => x !== item.id);
                            }

                            updateFilter("category", updated);
                          }}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              {/* <Accordion.Item eventKey="1">
                <Accordion.Header>Avaalability</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item> */}

              <Accordion.Item eventKey="2">
                <Accordion.Header>Color</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    {/* <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"Blue"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Green"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pink"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Belge"}
                      />
                    </Form> */}

                    <Form>
                      {colours?.map((item) => (
                        <Form.Check
                          key={item.id}
                          type="checkbox"
                          label={item.name}
                          checked={filters.colors.includes(item.id)}
                          onChange={(e) => {
                            let updated = [...filters.colors];

                            if (e.target.checked) {
                              updated.push(item.id);
                            } else {
                              updated = updated.filter((x) => x !== item.id);
                            }

                            updateFilter("colors", updated);
                          }}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>



              <Accordion.Item eventKey="3">
                <Accordion.Header>Size</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    {/* <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"Blue"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Green"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pink"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Belge"}
                      />
                    </Form> */}

                    <Form>
                      {sizes?.map((item) => (
                        <Form.Check
                          key={item.id}
                          type="checkbox"
                          label={item.name}
                          checked={filters.sizes.includes(item.id)}
                          onChange={(e) => {
                            let updated = [...filters.sizes];

                            if (e.target.checked) {
                              updated.push(item.id);
                            } else {
                              updated = updated.filter((x) => x !== item.id);
                            }

                            updateFilter("sizes", updated);
                          }}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* <Accordion.Item eventKey="3">
                <Accordion.Header>Size</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">

                    <Form>
                      {sizes?.map((item) => (
                        <Form.Check
                          key={item.id}
                          type="checkbox"
                          label={item.name}
                          checked={filters.sizes.includes(item.id)}
                          onChange={(e) => {
                            let updated = [...filters.sizes];

                            if (e.target.checked) {
                              updated.push(item.id);
                            } else {
                              updated = updated.filter((x) => x !== item.id);
                            }

                            updateFilter("sizes", updated);
                          }}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item> */}

              {/* Brand filter */}
              {/* <Accordion.Item eventKey="3">
                <Accordion.Header>Brand</Accordion.Header>

                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      {brands?.map((item) => (
                        <Form.Check
                          key={item.id}
                          type="checkbox"
                          label={item.name}
                          checked={filters.brands.includes(item.id)}
                          onChange={(e) => {
                            let updated = [...filters.brands];

                            if (e.target.checked) {
                              updated.push(item.id);
                            } else {
                              updated = updated.filter((x) => x !== item.id);
                            }

                            updateFilter("brands", updated);
                          }}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item> */}

              {/* <Accordion.Item eventKey="2">
                <Accordion.Header>Category</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Pack Size</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header>Discounts / Offers</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={1}
                        label={"In Stock"}
                      />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Out of Stock"}
                      />

                      <Form.Check type={"checkbox"} id={1} label={"Pre-order"} />

                      <Form.Check
                        type={"checkbox"}
                        id={1}
                        label={"Limited Stock"}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item> */}
            </Accordion>
          </div>
          <div className="buttons_div">
            <Green_round_btn
              btnText="Apply"
              onClick={() => {
                handleApplyFilters();
                handleClick();
                handleClose();
              }}
            />
            <Green_round_btn
              btnText="Clear"
              onClick={() => {
                handleClearFilters();
                handleClose();
              }}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_Modal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        successText="Applied Successfully!"
      />
    </>
  );
}

export default Filter_offcanvas;
